import React from "react";
import { Box } from "@mui/material";
import FrameCard from "../../shared/FrameCard";
import SectionTitle from "../../shared/SectionTitle";
import PersonSummary from "./PersonSummary";
import ProfileInfoItem from "./ProfileInfoItem";
import { useIsDesktop } from "../../shared/hooks/useIsDesktop";

/**
 * プロフィールセクション
 * - 左：人物サマリー
 * - 右：補足情報（PCは行単位で一致 / SPは上段2列＋下段全幅）
 */
const ProfileSection = ({ profile, isPublicPage }) => {
  const isDesktop = useIsDesktop();

  // 最寄駅、片方のみの場合は / なし、両方ない場合は未登録
  // 公開ページの場合は非公開表示
  const nearestStationValue = isPublicPage
    ? "非公開"
    : [profile.nearest_station_line, profile.nearest_station]
        .filter(Boolean)
        .join(" / ") || "未登録";

  return (
    <FrameCard>
      <Box>
        <SectionTitle title="プロフィール" />

        {/* 左（PersonSummary）＋右（InfoGrid） */}
        <Box
          sx={{
            mt: 2,
            display: "grid",
            gridTemplateColumns: isDesktop ? "0.9fr 1.1fr" : "1fr",
            columnGap: isDesktop ? 2 : 0,
            rowGap: isDesktop ? 3 : 1,
            alignItems: "start",
          }}
        >
          {/* 左：名前 */}
          <Box
            sx={{
              mb: isDesktop ? 0 : 1,
              alignSelf: isDesktop ? "center" : "start",
            }}
          >
            <PersonSummary
              name={profile.name}
              age={profile.age}
              gender={profile.gender}
            />
          </Box>

          {/* 右：補足情報 */}
          <Box
            sx={{
              display: "grid",
              // PC：行単位一致
              // SP：エンジニア歴/国籍は横並び、下2つは全幅
              gridTemplateColumns: isDesktop ? "0.8fr 1.2fr" : "1fr 1fr",
              columnGap: isDesktop ? 3 : 1.5,
              rowGap: 1.5,
              alignItems: "start",
            }}
          >
            {isDesktop ? (
              <>
                {/* PC：行1：エンジニア歴 / 最寄り駅 */}
                <ProfileInfoItem
                  label="エンジニア歴"
                  value={profile.engineer_history}
                />
                <ProfileInfoItem
                  label="最寄り駅"
                  value={nearestStationValue}
                  isPublicPage={isPublicPage}
                />

                {/* PC：行2：国籍 / 最終学歴 */}
                <ProfileInfoItem label="国籍" value={profile.nationality} />
                <ProfileInfoItem
                  label="最終学歴"
                  value={profile.final_academic_background}
                />
              </>
            ) : (
              <>
                {/* SP：上段2列 */}
                <ProfileInfoItem
                  label="エンジニア歴"
                  value={profile.engineer_history}
                />
                <ProfileInfoItem label="国籍" value={profile.nationality} />

                {/* SP：下段は全幅 */}
                <Box sx={{ gridColumn: "1 / -1" }}>
                  <ProfileInfoItem
                    label="最寄り駅"
                    value={nearestStationValue}
                    isPublicPage={isPublicPage}
                  />
                </Box>
                <Box sx={{ gridColumn: "1 / -1" }}>
                  <ProfileInfoItem
                    label="最終学歴"
                    value={profile.final_academic_background}
                  />
                </Box>
              </>
            )}
          </Box>
        </Box>
      </Box>
    </FrameCard>
  );
};

export default ProfileSection;
